import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../core/user.service';
import { AccessModules } from '../models/user.model';

   @Injectable({
     providedIn: 'root'
   })
   export class EstimationsGuard implements CanActivate {
    private accessPermissions?: AccessModules;
    
    constructor(private userService: UserService, private router: Router) {}

    async canActivate(): Promise<boolean> {
      if ((await firstValueFrom(this.userService.getAccessModules())).workProgressStatement) {
        return true;
      } else {
        this.router.navigate(['/']);
        return false;
      }
    }
   }